<script lang="ts">
    import Svg from "../common/Svg.svelte";
    import YearSlider from "./YearSlider.svelte";
    import type {SearchQuery} from "../NvbsSearchEngineApi/interfaces";


    let {
        cancel = () => {
        },
        searchStore = $bindable(),
        startYear = -4260212250000,
        endYear = 1924904580000
    }: {
        cancel: () => void;
        searchStore: SearchQuery;
        startYear?: number;
        endYear?: number;
    } = $props();


    let year_min = $state(startYear);
    let year_max = $state(endYear);

    function onchange(min: number, max: number) {
        searchStore.date_one = year_min;
        searchStore.date_two = year_max;
    }


</script>
<div class="date-select">
        <button class="cancel-button"
                onclick={cancel}
        >
            <Svg type="times"/>
        </button>

    <YearSlider bind:minValue={year_min} bind:maxValue={year_max} {onchange}/>
</div>

<style lang="scss">


  .date-select {
    background: #f0f0f0;
    margin-bottom: 10px;
    padding: 20px;

    .cancel-button {
      background: #375698;
      color: #fff;
      border: none;
      padding: 5px 10px;
      border-radius: 5px;
      cursor: pointer;
      transition: all 0.2s ease-in-out;

      margin-bottom: 20px;

      &:hover {
        background: #2c4a7f;
      }
    }
  }
</style>
